module.exports = __webpack_public_path__ + "static/media/PaidSocial_Ad05-Image.098312d1.jpg";